import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BaseBackResponse,
  REQUEST_LINE_STATUS,
  RequestLineStatus,
  SparePartStateUponReceipt,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}requestLine/update`;

interface UpdateSparePartRequestLineArgs {
  requestLineId: string;
  requestLineStatus: Exclude<
    RequestLineStatus,
    | typeof REQUEST_LINE_STATUS.ORDER_SUBMITTED
    | typeof REQUEST_LINE_STATUS.ORDER_COLLECTED
  >;
}

interface UpdateSparePartRequestLineSubmittedArgs {
  requestLineId: string;
  externalOrderId: string;
  purchasePrice: number;
  requestLineStatus: typeof REQUEST_LINE_STATUS.ORDER_SUBMITTED;
}
interface UpdateSparePartRequestLineOrderCollectedArgs {
  requestLineId: string;
  sparePartStateUponReceipt: SparePartStateUponReceipt;
  requestLineStatus: typeof REQUEST_LINE_STATUS.ORDER_COLLECTED;
  stockItemLocation: string;
  stockId: string;
}

export default async function updateSparePartRequestLine(
  payload:
    | UpdateSparePartRequestLineArgs
    | UpdateSparePartRequestLineSubmittedArgs
    | UpdateSparePartRequestLineOrderCollectedArgs,
): Promise<void> {
  const response = await apiCall<BaseBackResponse>(ENDPOINT, {
    method: SUPPORTED_METHODS.PUT,
    json: payload,
  });

  if (response.failure) {
    throw new Error(`Got an exception trying to updateSparePartRequestLine`);
  }
}
